const React = require('react');
const { default: CircularProgress } = require('@mui/material/CircularProgress');
const { default: Typography } = require('@mui/material/Typography');
const { default: Styled } = require('styled-components');
const CropAvatarDialog = require('components/CropAvatarDialog');
const ProfilePhotoActions = require('components/ProfilePhotoActions');
const { transient$Props } = require('utils/styles');
const useProfilePhotoController = require('./useProfilePhotoController');

const internals = {};

module.exports = function ProfilePhotoGroup(props = {}) {
    const {
        ErrorText,
        PreviewFrame,
        PreviewImage,
        ProgressWrap,
        Root
    } = internals;
    const {
        alt = 'Profile photo preview',
        dataFieldAttr = 'picFile',
        fieldNames,
        inputId = 'upload-profile-photo',
        inputLabel = 'Upload profile photo'
    } = props;

    const {
        actions,
        hasEditablePhoto,
        inputRef,
        profilePhotoHasError,
        picFileError,
        previewSrc,
        profilePhotoRef,
        state
    } = useProfilePhotoController({ fieldNames });

    const croppingFile = state.cropping;
    const isBusy = !!state.uploadingProfilePic || !!state.convertingProfilePic;

    return <Root>
        <PreviewFrame
            ref={profilePhotoRef}
            data-userinputs-field={dataFieldAttr}
            tabIndex={-1}
            $hasError={profilePhotoHasError}
        >
            <PreviewImage
                src={previewSrc}
                alt={alt}
            />
            <ProfilePhotoActions
                canEditPhoto={hasEditablePhoto}
                disabled={isBusy}
                onEdit={actions.editPhoto}
                onUpload={actions.uploadPhoto}
                onCapture={actions.capturePhoto}
            />
        </PreviewFrame>
        {isBusy && (
            <ProgressWrap>
                <CircularProgress size={24} />
            </ProgressWrap>
        )}
        <input
            id={inputId}
            ref={inputRef}
            type='file'
            accept='image/*'
            onChange={actions.choosePic}
            aria-invalid={!!picFileError}
            aria-label={inputLabel}
            title={inputLabel}
            style={{ display: 'none' }}
        />
        {picFileError && <ErrorText color='error' variant='body2'>
            {picFileError}
        </ErrorText>}
        <CropAvatarDialog
            open={!!croppingFile}
            file={croppingFile}
            onDone={actions.doneCropping}
            onClose={actions.closeCropping}
            editorProps={{
                crossOrigin: 'anonymous'
            }}
        />
    </Root>;
};

internals.Root = Styled.div`
    margin-bottom: ${({ theme }) => theme.spacing(1.5)};
    text-align: center;
`;

internals.PreviewFrame = Styled.div.withConfig(transient$Props)`
    display: inline-block;
    position: relative;
    margin-top: ${({ theme }) => theme.spacing(0.5)};
    margin-bottom: ${({ theme }) => theme.spacing(4.5)};
    border: 1px solid ${({ $hasError }) => ($hasError ? '#d32f2f' : 'transparent')};
    border-radius: ${({ theme }) => theme.shape.borderRadius * 2}px;
    padding: ${({ theme, $hasError }) => ($hasError ? theme.spacing(0.5) : 0)};
    scroll-margin-top: 140px;
`;

internals.PreviewImage = Styled.img`
    display: block;
    width: 245px;
    height: 245px;
    border-radius: ${({ theme }) => theme.shape.borderRadius * 2}px;
    object-fit: cover;
`;

internals.ProgressWrap = Styled.div`
    margin-top: ${({ theme }) => theme.spacing(1)};
`;

internals.ErrorText = Styled(Typography)`
    margin-top: ${({ theme }) => theme.spacing(-3)};
    margin-bottom: ${({ theme }) => theme.spacing(3)};
`;

module.exports.internals = internals;
